import { faCheck, faCirclePlus } from "@fortawesome/pro-regular-svg-icons";
import { printHTML } from "hooks/utils/formatter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonGsfurn from "components/General/ButtonGsfurn/ButtonGsfurn";
import { CartContext } from "context/CartContextProvider";
import Image from "next/image";
import { useContext, useState } from "react";
import ProductCard from "components/General/ProductCard/ProductCard";
import { useRouter } from "next/navigation";
import { ModalContext } from "@notanumber/nan-component-library";

const ProductPreparePackage = ({
  product_id,
  preparation_id,
  overlay_settings,
  upsell,
}) => {
  const { updateCartItemPreparation } = useContext(CartContext);
  const { closeOverlay } = useContext(ModalContext);
  const [showUpsellView, setShowUpsellView] = useState(preparation_id == null);
  const [preparePackageAdded, setPreparePackageAdded] = useState(false);
  const router = useRouter();

  return (
    <div className="flex flex-col w-full max-w-5xl bg-body">
      <div className="header h-auto md:h-[9.5rem] bg-dark-bg text-white flex py-8 md:py-0 pl-6 pr-20 xl:pl-10 lg:pr-[5.5rem] flex-row md:items-center">
        <div className="w-full lg:flex lg:justify-between lg:items-center">
          <div className="flex flex-row items-center gap-4 mb-6 lg:mb-0">
            <FontAwesomeIcon icon={faCheck} className="w-auto h-5" />
            <span className="text-base font-light">
              {preparePackageAdded
                ? "Het voorbereidingspakket is toegevoegd aan uw offerte!"
                : "Het product is toegevoegd aan uw offerte"}
            </span>
          </div>
          {showUpsellView && (
            <ButtonGsfurn
              size="xl"
              color="cart_add_btn"
              onClick={() => {
                router.push("/winkelwagen");
                closeOverlay();
              }}
            >
              Ga naar offerte aanvragen
            </ButtonGsfurn>
          )}
        </div>
      </div>
      <div className="flex flex-col gap-6 px-6 pt-8 pb-10 md:pt-10 md:pb-10 xl:px-10 main">
        {showUpsellView ? (
          <>
            <h3 className="mb-0">
              {overlay_settings?.titel_upsell_overlay ||
                "Misschien heb je ook dit nodig?"}
            </h3>
            <div className="flex w-full">
              <div className="grid w-full grid-cols-2 gap-x-4 sm:gap-6 lg:grid-cols-3">
                {upsell?.length > 0 &&
                  upsell?.map((product, idx) => {
                    return <ProductCard product={product} key={idx} />;
                  })}
              </div>
            </div>
          </>
        ) : (
          <>
            <h2 className="mb-0">
              {overlay_settings?.title ||
                "Wilt u ook een voorbereidingspakket toevoegen?"}
            </h2>
            <div className="flex flex-col gap-6 md:gap-10 lg:flex-row">
              <Image
                src={overlay_settings?.afbeelding?.url}
                alt={overlay_settings?.afbeelding?.alt}
                className="!w-auto !h-60 object-cover !relative rounded-10"
                fill
              />
              <div className="flex flex-col justify-between w-full gap-6 md:gap-8">
                <div className="content md:text-15 text-sm leading-normal xl:w-[40.25rem]">
                  {printHTML(overlay_settings?.inhoud)}
                </div>
                <div className="flex flex-col h-full gap-5 md:h-12 md:flex-row">
                  <ButtonGsfurn
                    size="xl"
                    color="yellow_grw"
                    onClick={() => {
                      if (updateCartItemPreparation) {
                        updateCartItemPreparation(product_id, preparation_id);
                      }
                      setShowUpsellView(true);
                      setPreparePackageAdded(true);
                    }}
                  >
                    <div className="flex flex-row gap-3">
                      <FontAwesomeIcon
                        icon={faCirclePlus}
                        className="w-6 h-6 text-white"
                      />
                      <div>Ja, voeg toe aan offerte</div>
                    </div>
                  </ButtonGsfurn>
                  <ButtonGsfurn
                    size="xl"
                    color="white_ghost_grw"
                    onClick={() => {
                      setShowUpsellView(true);
                    }}
                  >
                    Nee, voeg niet toe aan offerte
                  </ButtonGsfurn>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ProductPreparePackage;
